import { Button } from 'antd';
import React, { useEffect, useState } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import Producto from './producto';

const ProductosCarrito = ({ actualizarCarrito,refrescar }) => {
    const [productos, setProductos] = useState([]);
    const [recargar, setRecargar] = useState(false);
    const [total, setTotal] = useState(0)

    useEffect(() => {
        if (actualizarCarrito === true || recargar === true) {
            let carrito = JSON.parse(localStorage.getItem('productos')) || [];
            let total = 0

            carrito.reduce((valorPrevio, valorActual) => total += valorActual.precioOferta * valorActual.cantidad, 0);

            setProductos(carrito);
            setTotal(total);
            setRecargar(false);
            refrescar(true);
        }

    }, [actualizarCarrito, recargar]);


    return (
        <>
            <Container fluid>
                {productos && productos.length > 0 ?
                    productos.map((producto, index) => <Producto producto={producto} key={index} recargar={setRecargar} />)
                    :
                    <Row>
                        <Col xs={12} className="text-center my-5">
                            <h5 className="bold-title-hyundai f-responsive-14">No hay productos.</h5>
                        </Col>
                    </Row>
                }
                {productos && productos.length > 0 &&
                    <>
                        <Row className="mt-4 border-total">
                            <Col xs={6} className="my-3">
                                <h6 className="bold-title-hyundai mb-0 f-responsive">Total</h6>
                            </Col>
                            <Col xs={6} className="my-3">
                                <h6 className="bold-title-hyundai text-right mb-0 f-responsive">${total} <span className="iva">+IVA</span></h6>
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={11} md={10} className="text-center mx-auto my-4">
                                <Link to="/carrito">
                                    <Button className="w-100 btn-primario font-btn">Ir al carro de compra</Button>
                                </Link>
                            </Col>
                        </Row>
                    </>
                }
                <Row>
                    <Col xs={11} md={10} className="text-center mx-auto">
                        <Link to="/outlet/vehiculos">
                            <Button className="w-100 btn-secundario font-btn">Volver a Outlet</Button>
                        </Link>
                    </Col>
                </Row>
            </Container>
        </>
    );
}

export default ProductosCarrito;